module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-04.2535b036.jpg";